import { SearchMatchType } from '@aibees/elephant/types';
import { capitalize } from '@aibees/shared/utils';
import {
  ClassificationGroups,
  ClassificationType,
  FilterCategory,
  SearchFilterBase,
  SearchFilterType,
} from '../types';

export default function languageSkillsFilterConfig(): SearchFilterBase {
  return {
    name: 'Language Skills',
    icon: 'language',
    index: 22,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.CONTACT_DATA],
    utils: {
      tags: {
        config: {
          showAsCard: true,
          tagsCardTitle: 'Language Skills',
        },
      },
    },
    sections: { main: 2, more: 2 },
    pinned: true,
    items: [
      {
        name: 'Include',
        type: SearchFilterType.CUSTOM_SELECT,
        index: 0,
        exactMatch: {
          enabled: true,
          default: SearchMatchType.WORD,
          customOptions: [SearchMatchType.WORD, SearchMatchType.STRICT],
        },
        field: 'include_languages_for_contact',
        key: 'include_languages_for_contact',
        metadata: {
          color: 'primary',
          preset: 'language',
          placeholder: 'Include Language ( OR ) Search',
          autocomplete: {
            recent: false,
            checkboxPosition: 'left',
            multiple: true,
            allowCustomValuesByEnter: true,
          },
        },
        utils: {
          tags: { labelFormatter: capitalize },
        },
        searchKey: 'value',
        config: { labelKey: 'value', valueKey: 'value' },
        options: [
          {
            type: 'URL',
            value: `/elephant-management/um/classifications?size=25&page=0&group=${ClassificationGroups.PERSON}&key=${ClassificationType.LANGUAGE}`,
            label: '',
            icon: null,
            index: undefined,
          },
        ],
      },
      {
        name: 'Exclude',
        type: SearchFilterType.CUSTOM_SELECT,
        index: 1,
        exactMatch: {
          enabled: true,
          default: SearchMatchType.WORD,
          customOptions: [SearchMatchType.WORD, SearchMatchType.STRICT],
        },
        key: 'exclude_languages_for_contact',
        field: 'exclude_languages_for_contact',
        metadata: {
          color: 'error',
          icon: 'block',
          preset: 'language',
          placeholder: 'Exclude Language ( OR ) Search',
          autocomplete: {
            recent: false,
            checkboxPosition: 'left',
            multiple: true,
            allowCustomValuesByEnter: true,
          },
        },
        utils: {
          tags: { labelFormatter: capitalize },
        },
        searchKey: 'value',
        config: { labelKey: 'value', valueKey: 'value' },
        options: [
          {
            type: 'URL',
            value: `/elephant-management/um/classifications?size=25&page=0&group=${ClassificationGroups.PERSON}&key=${ClassificationType.LANGUAGE}`,
            label: '',
            icon: null,
            index: undefined,
          },
        ],
      },
      {
        name: 'Include (AND)',
        type: SearchFilterType.CUSTOM_SELECT,
        index: 2,
        exactMatch: {
          enabled: true,
          default: SearchMatchType.WORD,
          customOptions: [SearchMatchType.WORD, SearchMatchType.STRICT],
        },
        key: 'all_of_languages_for_contact',
        field: 'all_of_languages_for_contact',
        metadata: {
          color: 'warning',
          icon: 'add-task',
          preset: 'language',
          placeholder: 'Include Language ( AND ) Search',
          autocomplete: {
            recent: false,
            checkboxPosition: 'left',
            multiple: true,
            allowCustomValuesByEnter: true,
          },
        },
        utils: {
          tags: { labelFormatter: capitalize },
        },
        searchKey: 'value',
        config: { labelKey: 'value', valueKey: 'value' },
        options: [
          {
            type: 'URL',
            value: `/elephant-management/um/classifications?size=25&page=0&group=${ClassificationGroups.PERSON}&key=${ClassificationType.LANGUAGE}`,
            label: '',
            icon: null,
            index: undefined,
          },
        ],
      },
      {
        type: SearchFilterType.NUMBER_RANGE,
        icon: undefined,
        index: 3,
        field: 'number_of_languages_for_contact',
        key: 'number_of_languages_for_contact',
        name: '# of Language Skills',
        metadata: {
          color: 'primary',
        },
      },
    ],
  };
}
